module.exports = __webpack_public_path__ + "static/media/barrio-chino.18497ffd.md";